import React, {ReactNode} from "react";

import {Button} from "../Button";
import {ProgressBarHorizontal} from "../ProgressBarHorizontal";
import {ProgressCircle} from "../ProgressCircle";
import {RocketLaunch} from "../icons/RocketLaunchIcon";
import {Tooltip} from "../Tooltip";

import "./UpgradePlanCard.css";

export interface UpgradePlanCardProps {
    isCollapsed: boolean;
    title: string;
    daysLeftText: ReactNode;
    upgradeText: string;
    progress: number;
    onUpgradeClick: () => void;
}

export const UpgradePlanCard = ({
    isCollapsed,
    title,
    daysLeftText,
    upgradeText,
    progress,
    onUpgradeClick,
}: UpgradePlanCardProps) => {
    if (isCollapsed) {
        return (
            <Tooltip title={title}>
                <div className="UpgradePlanCardCollapsed label-small"
                     onClick={onUpgradeClick}
                >
                    <ProgressCircle
                        className=""
                        size={16}
                        circleThickness={3}
                        segments={[{
                            percentage: progress,
                            status: 'upgrade',
                        }]}
                    />
                </div>
            </Tooltip>
        );
    }

    return (
        <div className="UpgradePlanCard">
            <div className="UpgradePlanCard__header_row body-medium">
                <span className="UpgradePlanCard__header">{title}</span>
                <div className="UpgradePlanCard__tail">
                    {daysLeftText}
                    <RocketLaunch size={16} className="UpgradePlanCard__rocketIcon"/>
                </div>
            </div>
            <ProgressBarHorizontal
                className="UpgradePlanCard__ProgressBar"
                maxWidth={256}
                type="accent"
                progress={progress}
            />
            <Button
                className="UpgradePlanCard__button"
                text={upgradeText}
                type="accent"
                style="inline"
                size="sm"
                onClick={onUpgradeClick}
            />
        </div>
    );
};
